import React, { FC, useState } from 'react';
import Page2ColumnLayout from '../../components/utility/page2-column-layout';
import MainArea from '../../components/utility/main-area';
import { useTranslation } from '../../hooks/useTranslation';
import Helmet from 'react-helmet';
import NeedMoreTimeToPayForm from '../../components/need-more-time-to-pay';
import AccountLeftNavBlock from '../../components/utility/account-left-nav-block';

const NeedMoreTimeToPayPage: FC = () => {
  const { t } = useTranslation();

  return (
    <>
      <Helmet>
        <title>{t('NMTTP')}</title>
      </Helmet>
      <Page2ColumnLayout leftColumn={<AccountLeftNavBlock />}>
        <MainArea>
          <NeedMoreTimeToPayForm />
        </MainArea>
      </Page2ColumnLayout>
    </>
  );
};

export default NeedMoreTimeToPayPage;
